import { API_ENDPOINTS } from '~/Apis/api-library'

export function usePurchaseApi() {
	return {
		computeHealthPurchase: async (payload: HealthPurchaseContext) => {
			const { data } = await useAPI<IRequestResponse<HealthPurchaseResponse>>('/health/compute-health-premium', {
				method: 'PUT',
				body: {
					...payload,
					sales_type: 'new purchase'
				}
			})
			return data.value
		},
		computeAutoPurchase: async (
			product_type: 'third_party_comprehensive' | 'mini_comprehensive' | '',
			formData: AutoPurchaseFormContext
		) => {
			const body = {
				...formData,
				sales_type: 'new purchase'
			}
			if (product_type === String(ProductNames.MINI_COMPREHENSIVE).replace(' ', '_')) {
				const { data } = await useAPI<IRequestResponse<ComputedAutoFormResponse>>(
					'/auto/compute-mini-comprehensive-premium',
					{
						method: 'PUT',
						body
					}
				)
				return data.value
			}

			const { data } = await useAPI<IRequestResponse<ComputedAutoFormResponse>>(
				'/auto/compute-third-party-premium',
				{
					method: 'PUT',
					body
				}
			)
			return data.value
		},
		computedComprehensivePurchase: async (payload: ComputedComprehensiveContext) => {
			const { data } = await useAPI<IRequestResponse<ComputedComprehensiveResponse>>(
				'/auto/compute-comprehensive-auto-premium',
				{
					method: 'PUT',
					body: {
						...payload,
						sales_type: 'new purchase'
					}
				}
			)
			return data.value
		},
		computeGadgetPurchase: async (payload: ComputedGadgetPayload) => {
			const { data } = await useAPI<IRequestResponse<ComputeGadgetResponse>>(
				'/gadget/compute-gadget-cover-premium/',
				{
					method: 'PUT',
					body: payload
				}
			)
			return data.value
		},
		computeTravelPurchase: async (payload: ComputeTravelPayload) => {
			const { data } = await useAPI<IRequestResponse<ComputeTravelResponse>>(
				'/travel/compute-travel-cover-premium',
				{
					method: 'PUT',
					body: {
						...payload,
						sales_type: 'new purchase'
					}
				}
			)
			return data.value
		},
		purchaseAutoVehicles: async (
			product_type: 'third_party_comprehensive' | 'mini_comprehensive' | '',
			arg: AutoPurchaseFormContext
		) => {
			if (String(product_type).includes('third_party')) {
				const { data } = await useAPI<IRequestResponse<AutoPurchaseResponse>>(
					API_ENDPOINTS.PurchaseAutoVehiclesThirdParty,
					{
						method: 'POST',
						body: arg
					}
				)
				return data.value
			}
			const { data } = await useAPI<IRequestResponse<AutoPurchaseResponse>>(
				API_ENDPOINTS.PurchaseAutoVehiclesMiniComprehensive,
				{
					method: 'POST',
					body: arg
				}
			)
			return data.value
		},
		purchaseComprehensiveAuto: async (payload: ComprehensivePurchaseContext) => {
			const { data } = await useAPI<IRequestResponse<AutoPurchaseResponse>>(
				API_ENDPOINTS.PurchaseComprehensiveAuto,
				{
					method: 'POST',
					body: payload
				}
			)
			return data.value
		},
		purchaseGadget: async (payload: GadgetPurchaseContext) => {
			const { data } = await useAPI<IRequestResponse<ComputeGadgetResponse>>(API_ENDPOINTS['PurchaseGadget'], {
				method: 'POST',
				body: payload
			})
			return data.value
		},
		purchaseHealth: async (payload: HealthPurchaseContext) => {
			const { data } = await useAPI<IRequestResponse<HealthPurchaseResponse>>(
				API_ENDPOINTS['PurchaseHealthPlan'],
				{
					method: 'POST',
					body: payload
				}
			)
			return data.value
		},
		purchaseTavel: async (payload: TravelPurchaseContext) => {
			const { data } = await useAPI<IRequestResponse<ComputeTravelResponse>>(
				API_ENDPOINTS['PurchaseTravelPlan'],
				{
					method: 'POST',
					body: payload
				}
			)
			return data.value
		}
	}
}
